import { ACCENT, ICON_SIZE } from './constants';

export const IconHandshake = ({
  size = ICON_SIZE,
  color = ACCENT,
}: Landing.IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M11 17l-3-3 6-6 3 3"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 12l4-4 4 4-4 4-4-4z"
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M22 12l-4-4-4 4 4 4 4-4z"
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M14 14l2 2M10 18l1 1"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
